/* lib/api/demo.js — публичный демо-стенд (/business-demo).
 * Приём заявки «показать полный функционал» без авторизации. Возвращает сырой
 * контракт apiFetch {ok,status,data}. Данные iiko-отчётов идут через обычный
 * integrations-адаптер: apiFetch переписывает их префикс на /api/demo/iiko/* пока
 * открыт демо-маршрут (см. lib/api/client.js). */
import { apiFetch } from './client.js';

// payload — {name, phone, email, telegram?, pos?, comment?, consent,
//   heard_from?('recommendation'|'search'|'social'|'telegram'|'article'|'other'),
//   goals?:['foodcost'|'menu'|'aggregators'|'purchases'|'staff'|'other'],
//   intent?:'signup', company_website?(honeypot)}.
// intent='signup' → email обязателен; успешный ответ несёт signup_token (string)
// для хэндоффа на /signup. Ошибки: 400 DRF field-errors {field:[msgs]}, 429.
export const submitDemoLead = (payload) =>
  apiFetch('/api/demo/lead/', { method: 'POST', body: payload });

// sessionStorage-ключ хэндоффа «демо-стенд → регистрация»: LeadRequestModal кладёт
// {token: signup_token, email, name}; SignUp префиллит форму и шлёт token в register;
// SignIn (аккаунт уже существовал) привязывает онбординг-флоу через createOnboardingFlow.
export const DEMO_SIGNUP_STORAGE_KEY = 'restorium.demo_signup';
